(function () {

  'use strict';

  angular
    .module('app')
    .factory('LoadService', [LoadService]);

  function LoadService() {

    function show() {
      var element = document.querySelector('#loader');
      element.className += ' loading';
      return;
    }

    function hide() {
      var element = document.querySelector('#loader');
      element.className = 'loader-wrapper';
      return;
    }

    return {
      show: show,
      hide: hide
    };
  }
}());